import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

export const states: NgHybridStateDeclaration[] = [{
   name: 'app.admin.identityManagement.users.**',
   url: '/users',
   loadChildren: () => import('./admin/user-admin.module').then(m => m.UserAdminModule)
}];
